(function () {
  'use strict';

  var ITEM_SELECTOR = '.tp-product-variants-meta__item';
  var ACTIVE_CLASS = 'tp-product-variants-meta__item--active';
  var IMG_SIZES = '(min-width: 750px) 88px, 76px';

  /* ---------- Hidratacao: imagem / texto / cor por indice (JSON + data-index) ---------- */

  function hydrate(root) {
    var dataEl = root.querySelector('.tp-product-variants-meta__data');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var images = data.images || [];
    var texts = data.texts || [];
    var colors = data.colors || [];

    root.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      var i = parseInt(item.dataset.index, 10);
      if (isNaN(i)) return;

      var wrap = item.querySelector('.tp-product-variants-meta__image-wrap');
      var nameEl = item.querySelector('.tp-product-variants-meta__name');

      // Texto custom sobrescreve o titulo do produto
      var txt = texts[i];
      if (txt) {
        if (nameEl) nameEl.textContent = txt;
        item.setAttribute('aria-label', txt);
      }

      // Imagem custom sobrescreve a featured_image
      var url = images[i];
      if (url && wrap) {
        var alt = (nameEl ? nameEl.textContent : '') || '';
        var img = wrap.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');
          img.setAttribute('sizes', IMG_SIZES);
          img.src = url;
          img.alt = alt;
        } else {
          var newImg = document.createElement('img');
          newImg.loading = 'lazy';
          newImg.src = url;
          newImg.alt = alt;
          wrap.innerHTML = '';
          wrap.appendChild(newImg);
        }
      }

      // Cor de fundo custom
      var color = colors[i];
      if (color && wrap) {
        wrap.style.background = color;
      }
    });
  }

  function hydrateAll() {
    document.querySelectorAll('tp-product-variants-meta').forEach(hydrate);
  }

  /* ---------- Swap do produto (troca sem reload) ---------- */

  function showLoading(root) {
    if (!root) return;
    var overlay = root.querySelector('.tp-product-variants-meta__overlay');
    if (overlay) overlay.classList.add('tp-product-variants-meta__overlay--visible');
    var spinner = root.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }

  function hideLoading() {
    document
      .querySelectorAll('.tp-product-variants-meta__overlay--visible')
      .forEach(function (overlay) {
        overlay.classList.remove('tp-product-variants-meta__overlay--visible');
      });
  }

  async function swapProduct(item) {
    var url = item.dataset.productUrl;
    if (!url || item.classList.contains(ACTIVE_CLASS)) return;

    var root = item.closest('.tp-product-variants-meta');
    showLoading(root);

    try {
      var response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error('Fetch failed');

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var newProductInfo = doc.querySelector('product-info');
      var currentProductInfo = document.querySelector('product-info');

      if (newProductInfo && currentProductInfo) {
        // Atualiza a URL sem reload
        history.replaceState({}, '', url);

        // Troca o conteudo do product-info
        currentProductInfo.innerHTML = newProductInfo.innerHTML;

        // Copia atributos
        Array.from(newProductInfo.attributes).forEach(function (attr) {
          currentProductInfo.setAttribute(attr.name, attr.value);
        });

        // Re-executa os scripts do novo conteudo
        currentProductInfo.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(function (attr) {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        // Hidrata imediatamente os novos chips (sem esperar o re-fetch do script)
        hydrateAll();

        // Reinicializa botao de pagamento da Shopify
        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        // Atualiza o title da pagina
        var newTitle = doc.querySelector('title');
        if (newTitle) document.title = newTitle.textContent;
      } else {
        // Sem product-info no destino: navega normalmente
        window.location.href = url;
      }
    } catch (error) {
      console.error('[tp-product-variants-meta] Error loading product:', error);
      window.location.href = url;
    } finally {
      hideLoading();
    }
  }

  /* ---------- Bindings ---------- */

  // Delegacao global: independe do upgrade do custom element e sobrevive ao swap.
  if (!window.__tpVariantsMetaBound) {
    window.__tpVariantsMetaBound = true;
    document.addEventListener('click', function (event) {
      var item = event.target.closest(ITEM_SELECTOR);
      if (!item || !item.dataset.productUrl) return;
      event.preventDefault();
      swapProduct(item);
    });
  }

  // Hidrata no load inicial e a cada re-execucao do script (apos swap AJAX)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }
})();
